import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { FilterTypes } from '@app/infrastructure/filters/filters.model';

export class FilterAssistant {
	public static getDefaultFilterTypeControl(): FormControl {
		return new FormControl();
	}

	public static getKeyValueFilterTypeControl(): FormGroup {
		return new FormGroup({
			key: new FormControl(),
			value: new FormControl(),
		});
	}

	public static getMultipleKeyValueFilterTypeControl(): FormArray {
		return new FormArray([FilterAssistant.getKeyValueFilterTypeControl()]);
	}

	public static getRangeFilterTypeControl(): FormGroup {
		return new FormGroup({
			start: new FormControl(),
			end: new FormControl(),
		});
	}

	public static getFilterItemValueBasedOnFilterType(type: FilterTypes): FormGroup | FormArray | FormControl {
		return type === FilterTypes.RangeSelection
			? FilterAssistant.getRangeFilterTypeControl()
			: type === FilterTypes.KeyValueSelection
			? FilterAssistant.getKeyValueFilterTypeControl()
			: type === FilterTypes.MultipleKeyValueSelection
			? FilterAssistant.getMultipleKeyValueFilterTypeControl()
			: FilterAssistant.getDefaultFilterTypeControl();
	}
}
